<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h3 mat-dialog-title>Dynamic Color Settings</h3>
<p class="fieldName">Field: {{ name }}</p>

<div mat-dialog-content #target>
  <ng-container *ngIf="chartType == 'Table' && loading">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <table mat-table [dataSource]="dataSource" style="width: 100%">
    <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="white-space: nowrap;width:{{ col.width }}"
        [width]="col.width"
      >
        {{ col.label
        }}<span class="requiredAsterix" *ngIf="col.required">*</span>
      </th>
      <ng-container *matCellDef="let element; let i = index">
        <td mat-cell class="highchart">
          <div [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'position'">
              <span class="position">{{ i + 1 }}. </span>
            </ng-container>

            <ng-container *ngSwitchCase="'condition'"> Less than </ng-container>
            <ng-container *ngSwitchCase="'value'"> </ng-container>
            <ng-container *ngSwitchCase="'valueEnd'">
              <mat-form-field
                appearance="outline"
                class="form-input"
                style="margin-bottom: 0"
              >
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  [placeholder]="getPlaceholder(i + 1)"
                  name="value"
                  type="number"
                  id="value"
                  maxlength="30"
                  [ngClass]="{ required: dataSource.length != i + 1 }"
                  [required]="true"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            </ng-container>

            <ng-container *ngSwitchCase="'color'">
              <span style="display: inline-block; margin-left: 0px">
                <ngx-colors
                  ngx-colors-trigger
                  [(ngModel)]="element[col.key]"
                  [hideTextInput]="true"
                  [hideColorPicker]="true"
                ></ngx-colors>
              </span>
            </ng-container>

            <mat-form-field
              appearance="fill"
              class="form-input"
              *ngSwitchDefault
              style="
                margin-bottom: 0;
                margin-left: 5px;
                width: 98%;
                background-color: red;
              "
            >
              <input
                matInput
                [(ngModel)]="element[col.key]"
                placeholder="{{ element[col.placeholder] }}"
              />
            </mat-form-field>

            <div class="btn-edit" *ngSwitchCase="'isEdit'">
              <fa-icon
                [icon]="faTrash"
                style="cursor: pointer"
                (click)="removeRow(element.id)"
              ></fa-icon>
            </div>
          </div>
        </td>
      </ng-container>
      <td mat-footer-cell *matFooterCellDef>
        <ng-container *ngIf="dataSource.length > 0">
          <div [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'position'"></ng-container>
            <ng-container *ngSwitchCase="'value'"></ng-container>
            <ng-container *ngSwitchCase="'condition'"
              >All other values</ng-container
            >
            <ng-container *ngSwitchCase="'valueEnd'"></ng-container>

            <ng-container *ngSwitchCase="'color'">
              <span style="display: inline-block; margin-left: 0px">
                <ngx-colors
                  ngx-colors-trigger
                  [(ngModel)]="noLimitColor"
                  [hideTextInput]="true"
                  [hideColorPicker]="true"
                ></ngx-colors>
              </span>
            </ng-container>

            <div class="btn-edit" *ngSwitchCase="'isEdit'"></div>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsFooter"></tr>
  </table>

  <br />
  <div class="error" *ngIf="error">
    Two or more thresholds have the same value configuration
  </div>
</div>
<div mat-dialog-actions align="end">
  <button
    class="button-add-row button_small"
    mat-button
    (click)="addRow()"
    [disabled]="validateFormWithoutLimit()"
  >
    Add Threshold
  </button>
  <span class="spacer" style="flex: 1 1 auto"></span>
  <button mat-button mat-dialog-close class="button_small cancel" *ngIf="!auto">
    cancel
  </button>
  <button
    *ngIf="auto"
    mat-button
    class="button_small cancel"
    (click)="onCancelClick()"
    style="width: 130px"
  >
    cancel & remove
  </button>

  <button
    mat-button
    class="button_small"
    (click)="onConfirmClick()"
    [disabled]="validateForm()"
  >
    apply
  </button>
</div>
